<template>
<div class="page page-center">
    <div class="container-tight py-4">
        <div class="text-center mb-4">
            <router-link :to="{ 'name': 'home' }">
                <span v-html="require('@/assets/img/logo.svg').default" class="main-logo" />
            </router-link>
        </div>
        <form class="card card-md" @submit.prevent="login">
            <div class="card-body">
                <h2 class="card-title text-center mb-4">Sign in using one-time code</h2>

                <div class="mb-3 text-secondary text-center">We've just sent a one-time code to your email inbox. Please remember to check your spam folder as well.</div>
                <div class="mb-3">
                    <label class="form-label">Code</label>
                    <input type="code" class="form-control" placeholder="Enter code" v-model="code" required />
                </div>
                <div class="form-footer">
                    <div class="buttons">
                        <button type="submit" class="btn btn-primary w-100" :disabled="loading">Verify</button>
                    </div>
                </div>
            </div>
        </form>

        <div class="text-center text-secondary mt-3">
            <router-link :to="{ 'name': 'login' }">Back</router-link>
        </div>
    </div>
</div>
</template>

<script>
import Intercom from "@intercom/messenger-js-sdk";

export default {
    props: ["next", "email"],
    data() {
        return {
            code: "",
            loading: false
        };
    },
    methods: {
        login() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.$store.dispatch("auth/code", { email: this.email, code: this.code }).then(() => {
                this.flashSuccess("Login success");
                this.$store.dispatch("auth/info").then((data) => {
                    Intercom({
                        app_id: "qwsa3ken",
                        email: data.email,
                        name: data.name,
                        user_id: data.id,
                        created_at: data.created
                    });
                });

                if (this.next) {
                    this.$router.push(this.next);
                } else {
                    this.$router.push({ name: "home" });
                }
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>
